var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card text-left inverted size-sm" }, [
    _c(
      "div",
      {
        staticClass:
          "display-flex flex-column laptop:flex-row laptop:flex-items-center laptop:flex-content-between",
      },
      [
        _c(
          "div",
          {
            staticClass:
              "margin-bottom-xl laptop:margin-bottom-0 laptop:margin-right-xl",
          },
          [
            _vm._t("message", function () {
              return [
                _c(
                  "p",
                  { staticStyle: { "--paragraph-margin-bottom": "0" } },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "margin-right-sm",
                      staticStyle: {
                        "--fa-secondary-opacity": "1",
                        "--fa-secondary-color": "var(--fa-dk-blue)",
                        "--fa-primary-color": "var(--white)",
                      },
                      attrs: { icon: _vm.$v6.duotone.faCircleInfo, size: "xl" },
                    }),
                    _vm._v("\n\n          You're viewing\n          "),
                    _vm.subject
                      ? [_vm._v(_vm._s(_vm.subject) + " for")]
                      : _vm._e(),
                    _vm._v(
                      "\n          v" +
                        _vm._s(_vm.$releases.active.version) +
                        ", an older version of Font Awesome.\n        "
                    ),
                  ],
                  2
                ),
              ]
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _vm._t("action", function () {
              return [
                _c(
                  "site-link",
                  {
                    staticClass: "accent",
                    staticStyle: { "font-weight": "var(--font-weight-bold)" },
                    attrs: { to: _vm.link },
                  },
                  [
                    _vm._v("\n          View the latest!\n          "),
                    _c("font-awesome-icon", {
                      staticClass: "margin-left-xs",
                      attrs: { icon: _vm.$v6.solid.faArrowRight },
                    }),
                  ],
                  1
                ),
              ]
            }),
          ],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }